import { ToastContentProps } from 'react-toastify';
import { ButtonIcon } from 'src/general/components/Button/ButtonIcon';
import { IconCircleCrossFilled } from 'src/general/Icons/IconCircleCrossFilled';

export const CarComparisonDismissSnackbarButton = ({ closeToast }: Pick<ToastContentProps, 'closeToast'>) => (
  <ButtonIcon
    Icon={IconCircleCrossFilled}
    title="Dismiss"
    onClick={closeToast}
    variant="tertiary"
    size="xsmall"
    styling="round"
  />
);
